import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export const Benefits = () => {
  const benefits = [{
    title: 'Ahorrá horas de trabajo',
    desc: 'Dejá de buscar jurisprudencia dispersa o redactar desde una hoja en blanco. Usá modelos probados.'
  }, {
    title: 'Mayor seguridad jurídica',
    desc: 'Presentá tus amparos con la tranquilidad de contar con fundamentos sólidos y actualizados.'
  }, {
    title: 'Respaldo profesional',
    desc: 'Elevá la calidad de tus presentaciones ante los juzgados con argumentación de primer nivel.'
  }, {
    title: 'Rapidez de respuesta',
    desc: 'Ante una urgencia de salud de tu cliente, vas a poder accionar en tiempo récord.'
  }];
  return <section className="py-20 bg-legal-800 border-y border-legal-700" data-id="element-36">
      <div className="container mx-auto px-4" data-id="element-37">
        <div className="flex flex-col lg:flex-row items-center gap-12 max-w-6xl mx-auto" data-id="element-38">
          <div className="flex-1" data-id="element-39">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-40">
              El impacto en tu ejercicio profesional
            </h2>
            <p className="text-lg text-slate-400 mb-8" data-id="element-41">
              Este tratado no es teoría vacía. Es una inversión directa en la
              eficiencia de tu estudio jurídico.
            </p>

            <div className="space-y-6" data-id="element-42">
              {benefits.map((benefit, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: idx * 0.1
            }} className="flex gap-4" data-id="element-43">
                  <div className="mt-1" data-id="element-44">
                    <CheckCircle2 className="w-6 h-6 text-gold-500" data-id="element-45" />
                  </div>
                  <div data-id="element-46">
                    <h4 className="text-lg font-bold text-white mb-1" data-id="element-47">
                      {benefit.title}
                    </h4>
                    <p className="text-slate-400" data-id="element-48">{benefit.desc}</p>
                  </div>
                </motion.div>)}
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex-1 w-full" data-id="element-49">
            <div className="bg-legal-900 rounded-2xl p-8 border border-legal-700 shadow-2xl relative overflow-hidden" data-id="element-50">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gold-500/10 blur-3xl rounded-full" data-id="element-51"></div>
              <blockquote className="relative z-10" data-id="element-52">
                <p className="text-xl md:text-2xl font-serif text-slate-300 italic mb-6 leading-relaxed" data-id="element-53">
                  "La diferencia entre dudar ante una consulta de salud y tomar
                  el caso con total seguridad, radica en tener las herramientas
                  correctas a mano."
                </p>
                <footer className="flex items-center gap-4" data-id="element-54">
                  <div className="w-12 h-1 bg-gold-500" data-id="element-55"></div>
                  <span className="text-gold-500 font-bold tracking-wide uppercase text-sm" data-id="element-56">
                    Tu tranquilidad profesional
                  </span>
                </footer>
              </blockquote>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};